export enum LoginType {
  SSO = 'sso',
  USER_ACCOUNT = 'userAccount',
}
